/*global google:false*/

import React, { Component } from 'react';
import styled from 'styled-components';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

import Button from '../Button';

import { colors } from '../../../shared/styles';

const StyledGeoLocation = styled.div`
    padding: 0 20px 10px 20px;

    & label {
        font-size: 13px;
        display: block;
        padding: 16px 0 6px 0;
    }

    & .geo-wrapper {
        text-align: center;
        padding-top: 16px;
        padding-bottom: 10px;
    }

    & .map-wrapper {
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
        height: ${props =>
            props.mapHeight ? `${props.mapHeight}px` : '350px'};
    }
`;

const GeolocationGoogleMap = withGoogleMap(props =>
    <GoogleMap
        defaultZoom={15}
        defaultCenter={props.defaultLocation}
        options={{ streetViewControl: false }}
        ref={props.onMapLoad}
    >
        <Marker
            draggable={!props.isGeocoding}
            onDragEnd={props.onMarkerDrag}
            position={props.currentLocation}
            defaultAnimation={2}
        />
    </GoogleMap>
);

export default class Geolocation extends Component {
    constructor(props) {
        super(props);

        this._googleMap = null;
        this._geocoder = new google.maps.Geocoder();

        this.onLocationChange = this.onLocationChange.bind(this);
        this.onGeocode = this.onGeocode.bind(this);
        this.onMapLoad = this.onMapLoad.bind(this);
        this.onMarkerDrag = this.onMarkerDrag.bind(this);

        this.state = {
            isGeocoding: false,
            geocodeError: false,
        };
    }

    onGeocode() {
        this.setState({
            isGeocoding: true,
        });

        this._geocoder.geocode(
            { address: this.props.geocodeSourceValue, region: 'uk' },
            (results, status) => {
                if (status === 'OK') {
                    const loc = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng(),
                    };

                    this._googleMap.panTo(loc);

                    this.onLocationChange(loc);

                    this.setState({
                        isGeocoding: false,
                        geocodeError: false,
                    });

                    return;
                }

                this.setState({
                    isGeocoding: false,
                    geocodeError: true,
                });

                setTimeout(() => {
                    this.setState({
                        isGeocoding: false,
                        geocodeError: false,
                    });
                }, 10000);
            }
        );
    }

    onLocationChange(location) {
        this.props.input.onChange(location);
    }

    onMapLoad(map) {
        this._googleMap = map;
    }

    onMarkerDrag(event) {
        const loc = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        };

        this.onLocationChange(loc);
    }

    render() {
        const {
            geocodeSourceValue,
            hideLocateButton,
            mapHeight,
            label,
        } = this.props;
        const { isGeocoding, geocodeError } = this.state;
        const defaultLocation = this.props.latLng || {
            lat: 54.00366,
            lng: -2.547855,
        };
        const currentLocation = this.props.input.value || defaultLocation;

        let buttonText = geocodeSourceValue
            ? `Locate ${geocodeSourceValue}`
            : 'Enter a postcode to find';

        if (isGeocoding) {
            buttonText = 'Searching, please wait...';
        }

        if (geocodeError) {
            buttonText = `Unable to locate ${geocodeSourceValue}`;
        }

        const disableGeocode = !geocodeSourceValue || isGeocoding;

        return (
            <StyledGeoLocation mapHeight={mapHeight}>
                {!hideLocateButton &&
                    <div className="geo-wrapper">
                        <Button
                            type="button"
                            disabled={disableGeocode}
                            onClick={this.onGeocode}
                        >
                            {buttonText}
                        </Button>
                    </div>}
                {label &&
                    <label>
                        {label}:
                    </label>}
                <div className="map-wrapper">
                    <GeolocationGoogleMap
                        containerElement={<div style={{ height: `100%` }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        onMapLoad={this.onMapLoad}
                        onMarkerDrag={this.onMarkerDrag}
                        defaultLocation={currentLocation}
                        currentLocation={currentLocation}
                        isGeocoding={isGeocoding}
                    />
                </div>
            </StyledGeoLocation>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/forms/Geolocation.js